module.exports = __webpack_public_path__ + "static/img/guanbihuiyi2.ece93ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/guanbihuiyi2.png
// module id = xDJ3
// module chunks = 24